import { render, staticRenderFns } from "./selfFollow.vue?vue&type=template&id=2b5ca46f&scoped=true"
import script from "./selfFollow.vue?vue&type=script&lang=js"
export * from "./selfFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ca46f",
  null
  
)

export default component.exports